import React, { useState } from "react";
import { useEffect } from "react";
import axiosInstance from '../utilities/axiosInstance';
import { Listbox } from '@headlessui/react';
import { FaChevronDown, FaCheck } from 'react-icons/fa';
import clsx from 'clsx';
import { showAlert } from '../components/AlertPopup';


const CreateProfile = () => {
  const [formData, setFormData] = useState({
    id: [],
    fullName: "",
    email: "",
  });
  const [selectedProject, setSelectedProject] = useState("");

  const [selected, setSelected] = useState([]);
  const [numofmanagers, setNumOfManagers] = useState([]);
  const [projectList, setProjectList] = useState([]);
  const [email, setEmail] = useState("");
  const [validationMessage, setValidationMessage] = useState("");
  const [managerNameError, setManagerNameError] = useState(false);
  const [managers, setManagers] = useState([]);
  const [isManagerSelected, setIsManagerSelected] = useState(false);

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const localPart = email.substring(0, email.indexOf("@"));
    const localPartInvalidSymbols = /[^\w.]/;
    const atIndex = email.indexOf("@");
    const domainPart = email.substring(atIndex + 1);
    const dotIndex = email.lastIndexOf(".");
    if (!emailRegex.test(email)) {
      return false;
    }
    if (localPart.startsWith(".") || localPart.startsWith("_")) {
      return false;
    }
    if (localPartInvalidSymbols.test(localPart)) {
      return false;
    }
    if (localPart.includes("..")) {
      return false;
    }
    if (/\d/.test(domainPart)) {
      return false;
    }
    if (dotIndex === email.length - 1 || dotIndex < atIndex) {
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateEmail(email)) {
      setValidationMessage("");

      formData.id = selected;
      const randomNumber = Math.floor(Math.random() * 10000);
      const username =
        formData.fullName.split(" ").join("") + "." + randomNumber;
      const password = Math.random().toString(36).slice(-8);
      /* if (!formData.fullName) {
                return
            } */
      const formDataWithDetails = {
        ...formData,
        organizationname: formData.organizationname,
        name: formData.fullName,
        fullname: formData.fullName,
        username: username,
        password: password,
        confirmPassword: password,
        role: 2,
      };
      const response = await axiosInstance.post(`/create/profile`, formDataWithDetails);
      const data = response.data;
      showAlert(data.message, "success");
      setFormData({
        id: [],
        fullName: "",
        email: "",
        name: "",
        username: "",
        password: "",
        confirmPassword: "",
        organizationname: "",
        role: 2,
      });
      setSelectedProject("");
    } else {
      setValidationMessage("Invalid email, please provide valid email.");
    }
  };
  /**
   * Created By: Vikas Bose | 08/02/2024
   */
  const getListOfManager = async () => {
    await axiosInstance
      .get(`/listoworker`, {
        params: {
          role_id: 2,
        },
      })
      .then((response) => {
        setNumOfManagers(response.data);
        setManagers(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    const fetchProjects = async () => {
      const response = await axiosInstance.get(`/allprojects`);
      // const data = await response.json();
      setProjectList(response.data);
    };
    fetchProjects();
    getListOfManager();
  }, []);

  const handleChange = (eOrObject) => {
    let name, value;

    // Support both DOM event and manual object
    if (eOrObject?.target) {
      name = eOrObject.target.name;
      value = eOrObject.target.value;
    } else {
      name = 'projectNames';
      value = eOrObject;
    }

    // Set selected project IDs (as Listbox is now single-select)
    if (name === 'projectNames') {
      setSelected([value]); // make sure this is an array
    }

    if (name === "email") {
      setEmail(value);
    }

    if (name === "fullName") {
      if (value.length <= 25) {
        setFormData((prevFormData) => ({
          ...prevFormData,
          [name]: value,
        }));
      } else {
        setManagerNameError(true);
      }
    } else {
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: value,
      }));
    }
  };


  return (
    <>
      <h2 className="font-poppins font-medium text-[20px] leading-[100%] tracking-[0%] text-gray-main pb-3 border-b border-gray-d-200 dark:text-white dark:border-white">Create Profile (Manager)</h2>
      <div className=" max-w-[650px] mx-auto mt-11">
        <form
          className="profileContainer"
          onSubmit={handleSubmit}
          id="create-profile"
        >
          {/* <fieldset style={{border: '1px solid #000', padding:'20px', width:'800px'}}> */}
          {/* <legend>Create Profile:</legend> */}
          <div id="profile_content_wrapper">
            <div className="profile_content">

              <label className="font-poppins pl-5 mb-[5px] font-semibold text-[15px] leading-[22px] tracking-[0px] align-middle">Project Name</label>
              <div className="relative font-poppins text-[15px] mt-[5px] mb-[20px]">
                <Listbox value={selectedProject} onChange={(value) => {
                  setSelectedProject(value);
                  handleChange({ target: { name: 'projectNames', value } }); // mimic native event
                }}>
                  <div className="relative">
                    <Listbox.Button className="relative w-full h-[40px] cursor-pointer rounded-[22px] bg-white border border-gray-300 pl-5 pr-10 text-left shadow-sm focus:outline-none focus:ring-1 focus:ring-primary-color focus:border-primary-color">
                      <span className="block truncate text-gray-main">
                        {selectedProject
                          ? projectList.find(p => p.project_id === selectedProject)?.project_Name
                          : "Select Project"}
                      </span>
                      <span className="pointer-events-none absolute inset-y-0 right-3 flex items-center">
                        <FaChevronDown className="h-3 w-3 text-gray-400" />
                      </span>
                    </Listbox.Button>

                    <Listbox.Options className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-[10px] bg-gray-decent py-1 text-[14px] shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                      {projectList.map((project) => (
                        <Listbox.Option key={project.project_id} value={project.project_id}>
                          {({ active }) => (
                            <div
                              className={clsx(
                                "relative cursor-pointer select-none py-2 pl-2 pr-8 flex justify-between items-center border-b border-[#28325A26]",
                                {
                                  "text-deep-blue border-deep-blue": active,
                                  "text-gray-900": !active,
                                }
                              )}
                            >
                              <span>{project.project_Name}</span>
                              {(selectedProject === project.project_id || active) && (
                                <span className="absolute right-2 flex items-center justify-center h-[20px] w-[20px] bg-deep-blue rounded-full">
                                  <FaCheck className="text-white text-[10px]" />
                                </span>
                              )}
                            </div>
                          )}
                        </Listbox.Option>
                      ))}
                    </Listbox.Options>
                  </div>
                </Listbox>
              </div>


              <label className="font-poppins pl-5 mb-[5px] font-semibold text-[15px] leading-[22px] tracking-[0px] align-middle">Organization Name</label>

              <input
                type="text"
                name="organizationname"
                value={formData.organizationname}
                onChange={handleChange}
                required
                className="w-full h-[40px] mt-[5px] mb-[20px] rounded-[22px] bg-white border border-gray-300 pl-5 pr-5 text-left shadow-sm focus:outline-none focus:ring-1 focus:ring-primary-color focus:border-primary-color font-poppins text-[15px] text-gray-main"
              />

              <label className="font-poppins pl-5 mb-[5px] font-semibold text-[15px] leading-[22px] tracking-[0px] align-middle">Select Existing Manager</label>

              <div className="mt-[5px] mb-[20px]">
                <Listbox value={formData.fullName} onChange={(value) => {
                  const selectedManager = managers.find(manager => manager.profile_fullname === value);
                  if (selectedManager) {
                    setFormData({
                      ...formData,
                      fullName: selectedManager.profile_fullname,
                      email: selectedManager.profile_email,
                    });
                    setIsManagerSelected(true);
                    setEmail(selectedManager.profile_email);
                  } else {
                    setFormData({
                      ...formData,
                      fullName: "",
                      email: "",
                    });
                    setIsManagerSelected(false);
                  }
                }}>
                  <div className="relative font-poppins text-[15px] mt-2">
                    <Listbox.Button className="relative w-full h-[40px] cursor-pointer rounded-[22px] bg-white border border-gray-300 pl-5 pr-10 text-left shadow-sm focus:outline-none focus:ring-1 focus:ring-primary-color focus:border-primary-color">
                      <span className="block truncate text-gray-main">
                        {formData.fullName || "Select Existing Manager"}
                      </span>
                      <span className="pointer-events-none absolute inset-y-0 right-3 flex items-center">
                        <FaChevronDown className="h-3 w-3 text-gray-400" />
                      </span>
                    </Listbox.Button>

                    <Listbox.Options className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-[10px] bg-gray-decent py-1 text-[14px] shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                      {numofmanagers.map((manager) => (
                        <Listbox.Option
                          key={manager.profile_id}
                          value={manager.profile_fullname}
                        >
                          {({ active }) => (
                            <div
                              className={clsx(
                                "relative cursor-pointer select-none py-2 pl-2 pr-8 flex justify-between items-center border-b border-[#28325A26]",
                                {
                                  "text-deep-blue border-deep-blue": active,
                                  "text-gray-900": !active,
                                }
                              )}
                              style={{
                                color: manager.project_id && manager.project_id.trim() !== ""
                                  ? "red"
                                  : "black"
                              }}
                            >
                              <span>
                                {manager.profile_username} - {manager.project_id?.trim() ? "Project Assigned" : "No Project Assign"}
                              </span>
                              {(formData.fullName === manager.profile_fullname || active) && (
                                <span className="absolute right-2 flex items-center justify-center h-[20px] w-[20px] bg-deep-blue rounded-full">
                                  <FaCheck className="text-white text-[10px]" />
                                </span>
                              )}
                            </div>
                          )}
                        </Listbox.Option>
                      ))}
                    </Listbox.Options>
                  </div>
                </Listbox>
              </div>

              <div className="flex gap-[22px]">
                <div>
                  <label className="font-poppins pl-5 mb-[5px] font-semibold text-[15px] leading-[22px] tracking-[0px] align-middle">Manager's Full Name</label>
                  <input
                    type="text"
                    name="fullName"
                    value={formData.fullName}
                    onChange={handleChange}
                    required
                    disabled={isManagerSelected}
                    className={`w-full mt-[5px] mb-[20px] h-[40px] rounded-[22px] border border-gray-300 pl-5 pr-5 text-left shadow-sm focus:outline-none focus:ring-1 focus:ring-primary-color focus:border-primary-color font-poppins text-[15px] text-gray-main ${
                      isManagerSelected ? "bg-gray-200" : "bg-white"
                    }`}
                    />

                  {managerNameError ? (
                    <>
                      <label className="errormsg">
                        Max project name limit reached.
                      </label>

                    </>
                  ) : null}
                </div>

                <div>
                  <label className="font-poppins pl-5 mb-[5px] font-semibold text-[15px] leading-[22px] tracking-[0px] align-middle">Email</label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    disabled={isManagerSelected}
                    className={`w-full mt-[5px] mb-[20px] h-[40px] rounded-[22px] border border-gray-300 pl-5 pr-5 text-left shadow-sm focus:outline-none focus:ring-1 focus:ring-primary-color focus:border-primary-color font-poppins text-[15px] text-gray-main ${
                      isManagerSelected ? "bg-gray-200" : "bg-white"
                    }`}
                  />
                </div>
              </div>

              {validateEmail != "" ? (
                <p style={{ color: "red" }}>{validationMessage}</p>
              ) : null}
            </div>
            {/* <div className="profile_content">
            <h1>List of Manager</h1>
            
            
          </div> */}
          </div>
          {/* </fieldset> */}
          <div className="flex justify-end">
            <button
              type="submit"
              className="w-[150px] h-[40px] min-w-[150px] gap-[10px] rounded-[22px] px-[24px] py-[10px] text-white transition-all duration-1000 bg-gradient-to-r from-[#C300A0] to-[#00B4D2] group-hover:from-[#00B4D2] group-hover:to-[#C300A0]"
            >
              Add Profile
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

export default CreateProfile;
